import Text from 'components/shared/Text'
import { Wrapper } from './SelfcareCartItems.styles'
import { FormattedMessage } from 'react-intl'
import Box from 'components/shared/Box'
import Link from 'components/shared/Link'
import InlineTextList from 'components/shared/InlineTextList'
import Price from 'components/shared/Price'
import SeparatedList from 'components/shared/SeparatedList'
import { useContext } from 'react'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import Loader from 'components/shared/Loader'
import { useResolutions } from 'store/resolutions'
import { SELFCARE_STEPS } from 'routes/steps'
import { useApp } from 'store/steps'
import { useGuestsSelfcareCart } from 'components/common/MarchPromo/utils/useGuestsSelfcareCart'

const SelfcareCartItems = () => {
    const { isTablet } = useResolutions()
    const { navigateToStep } = useApp()

    const { marchVouchersData } = useContext(GuestsDataContext)
    const { cartItems } = useGuestsSelfcareCart()

    return (
        <Wrapper gap={[32, 48]}>
            {marchVouchersData.length === 0 || cartItems.length === 0 ? (
                <Loader />
            ) : (
                <>
                    <Box gap={8} isFullWidth>
                        <Box
                            direction="row"
                            justify="space-between"
                            align="center"
                            isFullWidth
                        >
                            <Text variant="heading3" color="secondary_700">
                                <FormattedMessage
                                    id="promo.march.promotion_vouchers_title"
                                    defaultMessage="_"
                                />
                            </Text>
                            <Link
                                variant="gray"
                                textVariant="bodySmallStrong"
                                icon={null}
                                onClick={() =>
                                    navigateToStep({
                                        stepId: SELFCARE_STEPS[1].id,
                                    })
                                }
                                data-testid="selfcare-summary-button-edit-vouchers"
                            >
                                <FormattedMessage
                                    id="selfcare.edit"
                                    defaultMessage="Edytuj"
                                />
                            </Link>
                        </Box>
                        <Text variant="bodySmall" color="grayscale_800">
                            <FormattedMessage
                                id="promo.march.promotion_vouchers_expiry"
                                defaultMessage="_"
                            />
                        </Text>
                    </Box>
                    <SeparatedList
                        gap={[16, 24]}
                        direction="column"
                        borderColor="grayscale_300"
                        borderWidth={2}
                        isFullWidth
                    >
                        {marchVouchersData.map((data) => {
                            const {
                                firstName,
                                lastName,
                                price,
                                tickets,
                                boxId,
                            } = data
                            const { person, zone, ticketType } = tickets[0]
                            const ticketsNumber = tickets.length

                            return (
                                <Box gap={16} key={boxId} isFullWidth>
                                    <Box
                                        direction="row"
                                        justify="space-between"
                                        align="center"
                                        isFullWidth
                                    >
                                        <Text
                                            variant="body"
                                            color="grayscale_900"
                                        >
                                            {firstName} {lastName}
                                        </Text>
                                        {isTablet && (
                                            <Box
                                                direction="row"
                                                gap={4}
                                                hasNoShrink
                                            >
                                                {ticketsNumber > 1 && (
                                                    <Text
                                                        variant="bodyStrong"
                                                        color="secondary_500"
                                                    >
                                                        {ticketsNumber} x
                                                    </Text>
                                                )}
                                                <Price
                                                    value={price || null}
                                                    size="bodyStrong"
                                                    currencySize="bodyStrong"
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                    <Box
                                        direction="row"
                                        justify="space-between"
                                        align="center"
                                        isFullWidth
                                    >
                                        <Box
                                            direction="row"
                                            justify="flex-start"
                                            align="baseline"
                                            gap={4}
                                        >
                                            <InlineTextList
                                                variant="body14"
                                                color="grayscale_900"
                                                items={[
                                                    person,
                                                    zone,
                                                    ticketType,
                                                ]}
                                                hasNoWrapItems={!isTablet}
                                                gap={[8, 16]}
                                            />
                                            {ticketsNumber > 1 && (
                                                <Text
                                                    variant="bodySmall"
                                                    color="primary_500"
                                                >
                                                    {`(${ticketsNumber}x)`}
                                                </Text>
                                            )}
                                        </Box>
                                        {!isTablet && (
                                            <Box
                                                direction="row"
                                                gap={4}
                                                hasNoShrink
                                            >
                                                {ticketsNumber > 1 && (
                                                    <Text
                                                        variant="bodyStrong"
                                                        color="secondary_500"
                                                    >
                                                        {ticketsNumber} x
                                                    </Text>
                                                )}
                                                <Price
                                                    value={price || null}
                                                    size="bodyStrong"
                                                    currencySize="bodyStrong"
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            )
                        })}
                    </SeparatedList>
                </>
            )}
        </Wrapper>
    )
}

export default SelfcareCartItems
